import Enterprise from "./Enterprise";

export default Enterprise;
